import { Input } from '@eika/input';
import { StandardButton } from '@eika/button';
import { array, arrayOf, func, number, shape, string } from 'prop-types';
import React from 'react';
import DropDown from '../../../drop-down';
import getLabel, { getHelpBody } from '../labels';
import Textarea from './textarea';
import ErrorMessage from '../../errormessage';

const Skatterelasjon = ({
    relasjon,
    handleFieldChange,
    removeself,
    index,
    skatterelasjonLandOptions,
    ekstratekster,
    relasjonErrors,
    removeValue,
}) => (
    <div className="rr-tax-relation skjema-input-field-wrap-small skjema-input-field-wrap">
        <div className="rr-skatterelasjon-header" style={{ fontSize: '20px' }}>
            {`Skatterelasjon ${index + 1}`}
            {index > 0 && <StandardButton className="removeicon" onClick={removeself} />}
        </div>

        <div className="skjema-input-field-wrap-small skjema-input-field-wrap">
            <DropDown
                values={skatterelasjonLandOptions}
                selected={relasjon.land || ''}
                label={getLabel(ekstratekster, 'rr_crsland')}
                selectValue={handleFieldChange('land')}
                errorText={relasjonErrors.includes('land') ? getLabel(ekstratekster, 'rr_crsland_instruks') : null}
                modalHelpHeader={ekstratekster.rr_crsland_infotittel}
                modalHelpBody={getHelpBody(ekstratekster, 'rr_crsland_info')}
                removeValue={() => removeValue('land')}
            />
        </div>

        <div className="skjema-input-field-wrap-small skjema-input-field-wrap">
            <Input
                className="rr-skattenummer"
                id={relasjon.relasjonId}
                label={getLabel(ekstratekster, 'rr_crsnummer')}
                name={`skattenummer_${relasjon.relasjonId}`}
                type="tel"
                onChange={handleFieldChange('skattenummer')}
                value={relasjon.skattenummer || ''}
                modalHelpHeader={ekstratekster.rr_crsnummer_infotittel}
                modalHelpBody={getHelpBody(ekstratekster, 'rr_crsnummer_info')}
            />
            {relasjonErrors.includes('skattenummer') && (
                <ErrorMessage text={getLabel(ekstratekster, 'rr_crsnummer_instruks')} />
            )}
        </div>

        <div className="skjema-input-field-wrap-small skjema-input-field-wrap">
            <Textarea
                className="rr-skattenummerMangler"
                id={relasjon.relasjonId}
                label={getLabel(ekstratekster, 'rr_crsmangler')}
                name={`skattenummerMangler_${relasjon.relasjonId}`}
                onChange={handleFieldChange('skattenummerMangler')}
                value={relasjon.skattenummerMangler || ''}
                errorText={
                    relasjonErrors.includes('skattenummerMangler')
                        ? getLabel(ekstratekster, 'rr_crsmangler_instruks')
                        : null
                }
                modalHelpHeader={ekstratekster.rr_crsmangler_infotittel}
                modalHelpBody={getHelpBody(ekstratekster, 'rr_crsmangler_info')}
            />
        </div>
    </div>
);

Skatterelasjon.propTypes = {
    relasjon: shape({
        relasjonId: string.isRequired,
        land: string,
        skattenummer: string,
        skattenummerMangler: string,
    }),
    handleFieldChange: func,
    index: number,
    removeself: func,
    skatterelasjonLandOptions: arrayOf(
        shape({
            value: string.isRequired,
            text: string.isRequired,
        })
    ),
    ekstratekster: shape({
        rr_crsland: string,
        rr_crsland_info: string,
        rr_crsland_infotittel: string,
        rr_crsland_instruks: string,
        rr_crsmangler: string,
        rr_crsmangler_info: string,
        rr_crsmangler_infotittel: string,
        rr_crsmangler_instruks: string,
        rr_crsnummer: string,
        rr_crsnummer_info: string,
        rr_crsnummer_infotittel: string,
        rr_crsnummer_instruks: string,
    }),
    relasjonErrors: array,
};

export default React.memo(Skatterelasjon);
